import React, { useState, useEffect } from "react";
import { http } from "../../axios/axios";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight, Box } from "lucide-react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Grid } from "swiper/modules";


import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/grid";

import SectionHeader from "../SectionHeader";
import ProductCard from "../ProductCard";

const TrendingPage = ({ type = "catalog" }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const location = useLocation();
  const isIpNetwork = type === "ip-network";

  const isProductDetailsPage =
    location.pathname.startsWith("/security-product/") ||
    location.pathname.startsWith("/it-products/");

  /*
  |--------------------------------------------------------------------------
  | Fetch Trending Products
  |--------------------------------------------------------------------------
  */

  useEffect(() => {
    const fetchTrending = async () => {
      try {
        setLoading(true);
        const res = await http.get("/products/trending", {
          params: {
            limit: 40,
            catalogType: type,
          },
        });

        setProducts(res.data?.products || []);
      } catch (error) {
        console.error("Trending Products Error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTrending();
  }, [type]);

  /*
  |--------------------------------------------------------------------------
  | Loading Skeleton
  |--------------------------------------------------------------------------
  */

  if (loading) {
    return (
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="h-12 w-64 bg-slate-100 rounded mb-10 animate-pulse" />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
            <div
              key={i}
              className="h-80 bg-slate-50 animate-pulse rounded-[2.5rem]"
            />
          ))}
        </div>
      </div>
    );
  }

  return (
    <section
      className={`${
        isProductDetailsPage
          ? "mt-16 border-t border-slate-100 pt-6"
          : "px-4 sm:px-6 lg:px-8 pt-6 md:pt14 pb-10"
      }`}
    >
      {/* Header */}

      <SectionHeader
        badge="Live Inventory"
        title="Trending Assets"
        description={
          <span className="lg:whitespace-nowrap">
            Explore our most viewed security, surveillance and products, trusted
            across government, enterprise and industrial sectors.
          </span>
        }
        showLine={true}
        action={
          <Link
            to={isIpNetwork ? "/it-products" : "/security-product"}
            className="
              group
              inline-flex
              items-center
              gap-2
              text-sm
              font-semibold
              text-slate-700
              hover:text-blue-600
              transition-colors
            "
          >
            View All Products

            <ArrowRight
              size={16}
              className="
                group-hover:translate-x-1
                transition-transform
              "
            />
          </Link>
        }
      />

      {/* =========================================
          PRODUCT CAROUSEL
      ========================================== */}

      {products.length > 0 && (
        <div className="w-full overflow-hidden">
          {/* <Swiper
            modules={[Autoplay, Pagination, Grid]}

          

            slidesPerView={1}
            slidesPerGroup={1}
            spaceBetween={12}

            grid={{
              rows: 1,
              fill: "row",
            }}

            speed={600}

            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}

            pagination={{
              clickable: true,
            }}

            

            loop={products.length > 8}

            

            breakpoints={{
              
              // | Mobile / Small Tablet
              
              640: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 16,

                grid: {
                  rows: 1,
                  fill: "row",
                },
              },

              
              // | Tablet
              
              768: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 18,

                grid: {
                  rows: 1,
                  fill: "row",
                },
              },

              
              // | Desktop
              // |
              // | 4 columns
              // | 2 rows
              // | Total visible products = 8
              // | Swipe 8 products together
              
              1024: {
                slidesPerView: 4,
                slidesPerGroup: 8,
                spaceBetween: 20,

                grid: {
                  rows: 2,
                  fill: "row",
                },
              },
            }}

            className="pb-12"
          >
            {products.map((item) => (
              <SwiperSlide
                key={item._id}
                className="h-auto"
              >
                <ProductCard item={item} />
              </SwiperSlide>
            ))}
          </Swiper> */}
          <Swiper
  modules={[Autoplay, Pagination, Grid]}
  slidesPerView={1}
  slidesPerGroup={1}
  spaceBetween={12}
  speed={700}

  autoplay={{
    delay: 5000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  }}

  pagination={{
    clickable: true,
  }}

  loop={false}
  rewind={true}

  grid={{
    rows: 1,
    fill: "row",
  }}

  breakpoints={{
    // Mobile
    0: {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 12,
      grid: {
        rows: 1,
        fill: "row",
      },
    },

    // Small devices
    640: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 16,
      grid: {
        rows: 1,
        fill: "row",
      },
    },

    // Tablet
    768: {
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 18,
      grid: {
        rows: 1,
        fill: "row",
      },
    },

    // Desktop
    1024: {
      slidesPerView: 4,
      slidesPerGroup: 4,
      spaceBetween: 20,

      grid: {
        rows: 2,
        fill: "row",
      },
    },
  }}

  className="pb-12"
>
  {products.map((item) => (
    <SwiperSlide key={item._id} className="h-auto">
      <ProductCard item={item} />
    </SwiperSlide>
  ))}
</Swiper>
        </div>
      )}

      {/* =========================================
          EMPTY STATE
      ========================================== */}

      {!loading && products.length === 0 && (
        <div
          className="
            py-20
            text-center
            border
            border-dashed
            border-slate-300
            rounded-2xl
            bg-slate-50
          "
        >
          <Box
            size={40}
            className="mx-auto text-slate-300 mb-4"
          />

          <h3 className="text-lg font-semibold text-slate-700 mb-2">
            No Products Available
          </h3>

          <p className="text-sm text-slate-500">
            We are currently updating our product collection. Please check back
            soon.
          </p>
        </div>
      )}
    </section>
  );
};

export default TrendingPage;